<div class="main-content">
  <!-- <app-operator-dropdown (operatorEvent)="operatorEvent($event)"></app-operator-dropdown>

<app-merchant-dropdown [operator]="operator" (onSelectMerchant)="onSelectMerchant($event)"></app-merchant-dropdown>

<span style="padding-left: 10px;"></span>
<button nz-button nzType="primary" (click)="loadTraffic()">
  <span nz-icon nzType="search"></span>
  Search
</button> -->


  <div class="d-flex-filter">
    <div class="d-flex-inner-item">
      <app-operator-dropdown (operatorEvent)="operatorEvent($event)"></app-operator-dropdown>
      <app-merchant-dropdown [operator]="operator"
        (onSelectMerchant)="onSelectMerchant($event)"></app-merchant-dropdown>

      <button nz-button nzType="primary" (click)="loadTraffic()">
        <span nz-icon nzType="search"></span>
        Search
      </button>
    </div>

    <div>
      Remaining
      <strong *ngIf="remainingTrafficCount.dcbRemainingCount>0"> DCB
        <nz-badge [nzStyle]="{ backgroundColor: '#52c41a' }" [nzShowZero]="true" nzStandalone
          [nzOverflowCount]="1000000" [nzCount]="remainingTrafficCount.dcbRemainingCount "></nz-badge>
      </strong>

      <strong *ngIf="remainingTrafficCount.dobRemainingCount>0"> DOB
        <nz-badge [nzStyle]="{ backgroundColor: '#52c41a' }" [nzShowZero]="true" nzStandalone
          [nzOverflowCount]="1000000" [nzCount]="remainingTrafficCount.dobRemainingCount "></nz-badge>
      </strong>


    </div>

  </div>


  <div>
    <nz-table [nzScroll]="{ x: '1100px' }" [nzLoading]="loading" style="padding-top: 20px; border:none" #smallTable nzSize="small"
      [nzData]="trafficData" [nzShowPagination]="false" [nzBordered]="true">
      <thead>
        <tr>
          <th nzWidth="100px">Date</th>
          <th nzWidth="100px">Plan</th>
          <th nzWidth="70px">Total</th>
          <th nzWidth="70px"> 00-01 </th>
          <th nzWidth="70px"> 01-02 </th>
          <th nzWidth="70px"> 02-03 </th>
          <th nzWidth="70px"> 03-04 </th>
          <th nzWidth="70px"> 04-05 </th>
          <th nzWidth="70px"> 05-06 </th>
          <th nzWidth="70px"> 06-07 </th>
          <th nzWidth="70px"> 07-08 </th>
          <th nzWidth="70px"> 08-09 </th>
          <th nzWidth="70px"> 09-10 </th>
          <th nzWidth="70px"> 10-11 </th>
          <th nzWidth="70px"> 11-12 </th>
          <th nzWidth="70px"> 12-01 </th>
          <th nzWidth="70px"> 01-02 </th>
          <th nzWidth="70px"> 02-03 </th>
          <th nzWidth="70px"> 03-04 </th>
          <th nzWidth="70px"> 04-05 </th>
          <th nzWidth="70px"> 05-06 </th>
          <th nzWidth="70px"> 06-07 </th>
          <th nzWidth="70px"> 07-08 </th>
          <th nzWidth="70px"> 08-09 </th>
          <th nzWidth="70px"> 09-10 </th>
          <th nzWidth="70px"> 10-11 </th>
          <th nzWidth="70px"> 11-12 </th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of smallTable.data">
          <td>{{ data.reportDate| date }}</td>
          <td>{{ removeFirstWord(data.hour) }}</td>
          <td>{{ data.total }}</td>
          <td>{{ data.aM0001 }}</td>
          <td>{{ data.aM0102 }}</td>
          <td>{{ data.aM0203 }}</td>
          <td>{{ data.aM0304 }}</td>
          <td>{{ data.aM0405 }}</td>
          <td>{{ data.aM0506 }}</td>
          <td>{{ data.aM0607 }}</td>
          <td>{{ data.aM0708 }}</td>
          <td>{{ data.aM0809 }}</td>
          <td>{{ data.aM0910 }}</td>
          <td>{{ data.aM1011 }}</td>
          <td>{{ data.pM1112 }}</td>
          <td>{{ data.pM1201 }}</td>
          <td>{{ data.pM0102 }}</td>
          <td>{{ data.pM0203 }}</td>
          <td>{{ data.pM0304 }}</td>
          <td>{{ data.pM0405 }}</td>
          <td>{{ data.pM0506 }}</td>
          <td>{{ data.pM0607 }}</td>
          <td>{{ data.pM0708 }}</td>
          <td>{{ data.pM0809 }}</td>
          <td>{{ data.pM0910 }}</td>
          <td>{{ data.pM1011 }}</td>
          <td>{{ data.aM1112 }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <br>


  <div class="d-flex-filter">
    <div class="d-flex-inner-item">
    <nz-range-picker [(ngModel)]="date"   (ngModelChange)="onChange($event)"></nz-range-picker>
    
    <button nz-button nzType="primary" (click)="loadArchiveTraffic()">
      <span nz-icon nzType="search"></span>
      Search
    </button> 
    </div>

  </div>



  <div>
    <nz-table [nzScroll]="{ x: '1100px' }" [nzLoading]="archiveLoading" style="padding-top: 20px;" #archiveTable nzSize="small"
      [nzData]="archiveTrafficData" [nzShowPagination]="false" [nzBordered]="true"
      [nzShowPagination]="true">
      <thead>
        <tr>
          <th nzWidth="100px">Date</th>
          <th nzWidth="100px">Plan</th>
          <th nzWidth="70px">Total</th>
          <th nzWidth="70px"> 00-01 </th>
          <th nzWidth="70px"> 01-02 </th>
          <th nzWidth="70px"> 02-03 </th>
          <th nzWidth="70px"> 03-04 </th>
          <th nzWidth="70px"> 04-05 </th>
          <th nzWidth="70px"> 05-06 </th>
          <th nzWidth="70px"> 06-07 </th>
          <th nzWidth="70px"> 07-08 </th>
          <th nzWidth="70px"> 08-09 </th>
          <th nzWidth="70px"> 09-10 </th>
          <th nzWidth="70px"> 10-11 </th>
          <th nzWidth="70px"> 11-12 </th>
          <th nzWidth="70px"> 12-01 </th>
          <th nzWidth="70px"> 01-02 </th>
          <th nzWidth="70px"> 02-03 </th>
          <th nzWidth="70px"> 03-04 </th>
          <th nzWidth="70px"> 04-05 </th>
          <th nzWidth="70px"> 05-06 </th>
          <th nzWidth="70px"> 06-07 </th>
          <th nzWidth="70px"> 07-08 </th>
          <th nzWidth="70px"> 08-09 </th>
          <th nzWidth="70px"> 09-10 </th>
          <th nzWidth="70px"> 10-11 </th>
          <th nzWidth="70px"> 11-12 </th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of archiveTable.data">
          <td>{{ data.reportDate| date }}</td>
          <td>{{ removeFirstWord(data.hour) }}</td>
          <td>{{ data.total }}</td>
          <td>{{ data.aM0001 }}</td>
          <td>{{ data.aM0102 }}</td>
          <td>{{ data.aM0203 }}</td>
          <td>{{ data.aM0304 }}</td>
          <td>{{ data.aM0405 }}</td>
          <td>{{ data.aM0506 }}</td>
          <td>{{ data.aM0607 }}</td>
          <td>{{ data.aM0708 }}</td>
          <td>{{ data.aM0809 }}</td>
          <td>{{ data.aM0910 }}</td>
          <td>{{ data.aM1011 }}</td>
          <td>{{ data.pM1112 }}</td>
          <td>{{ data.pM1201 }}</td>
          <td>{{ data.pM0102 }}</td>
          <td>{{ data.pM0203 }}</td>
          <td>{{ data.pM0304 }}</td>
          <td>{{ data.pM0405 }}</td>
          <td>{{ data.pM0506 }}</td>
          <td>{{ data.pM0607 }}</td>
          <td>{{ data.pM0708 }}</td>
          <td>{{ data.pM0809 }}</td>
          <td>{{ data.pM0910 }}</td>
          <td>{{ data.pM1011 }}</td>
          <td>{{ data.aM1112 }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>